export const classNameTag = (...parts) => `rondo-${parts.join('__')}`;
//# sourceMappingURL=class-name-tag.js.map